import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcModSev = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.7335 1.62225C6.7335 1.27859 6.45491 1 6.11125 1H3.62225C3.27859 1 2.99999 1.27859 3 1.62225C3.00007 6.03845 3.0008 10.4547 3.00014 14.8709C2.99999 15.871 3.38899 16.8444 4.16021 17.4813C7.22631 20.0132 11.158 21.5343 15.4449 21.5343C19.732 21.5343 23.6637 20.013 26.7299 17.481C27.5009 16.8443 27.8899 15.8713 27.8899 14.8714L27.89 1.62226C27.89 1.27859 27.6114 1 27.2677 1H24.7788C24.4351 1 24.1565 1.27859 24.1565 1.62225V14.7611C23.5707 15.2273 22.9465 15.6475 22.2898 16.0163V12.2005C22.2898 11.8568 22.0112 11.5783 21.6675 11.5783H19.1785C18.8348 11.5783 18.5563 11.8568 18.5563 12.2005V17.4538C18.1479 17.5465 17.7328 17.6213 17.3118 17.6774V12.2005C17.3118 11.8568 17.0332 11.5783 16.6895 11.5783H14.2005C13.8568 11.5783 13.5782 11.8568 13.5782 12.2005V17.6774C13.1572 17.6213 12.7421 17.5465 12.3337 17.4539V12.2005C12.3337 11.8568 12.0552 11.5783 11.7115 11.5783H9.2225C8.87884 11.5783 8.60025 11.8568 8.60025 12.2005V16.0165C7.94341 15.6477 7.31934 15.2274 6.7335 14.7612V1.62225Z",
		fill: "#FF3844"
	})
});
export default SvgIcModSev;
